import 'lazysizes'
import { lenis } from './lenis';

/**
 * Functionality here will be executed on all pages
 */

export const global = (): void => {
    lenis()
}

export function equalHeights(elm: string) {
    let maxHeight = 0;
    const items = (typeof elm == "string") ? document.querySelectorAll(elm) : null;

    if (items) {
        items.forEach(el => {
            maxHeight = Math.max(el.clientHeight, maxHeight);
        });
    
        items.forEach(el => {
            (el as HTMLElement).style.height = `${maxHeight}px`;
        });
    }

    return `${maxHeight}px`;
}

export const DEBUGGING = process.env.NODE_ENV === 'development' ? true : false;